export default __webpack_public_path__ + "media/images/avatars/avatar9-72e912f330a874361babe255670f0842.png";